import { useState } from "react";

import type { Exercise, ExerciseDraft } from "../lib/api";
import ExerciseSearch from "../components/ExerciseSearch";
import { useSheetDrag } from "../lib/useSheetDrag";

interface Props {
  onPick: (draft: ExerciseDraft) => void;
  onClose: () => void;
}

/**
 * Выбор упражнения и его цели.
 *
 * Шторка снизу, а не отдельный экран: пользователь добавляет несколько
 * упражнений подряд, и уводить его с программы на каждое — лишний путь.
 */
export default function ExercisePicker({ onPick, onClose }: Props) {
  const [picked, setPicked] = useState<Exercise | null>(null);
  const body = useSheetDrag(onClose);
  const [sets, setSets] = useState("3");
  const [reps, setReps] = useState("8");

  function submit() {
    if (!picked) return;
    // «8-12» — привычная запись диапазона, разбираем её здесь, а не заставляем
    // человека заполнять два поля.
    const [min, max] = reps.split("-").map((p) => Number(p.trim()));
    onPick({
      exercise_id: picked.id,
      target_sets: Number(sets) || null,
      target_reps_min: min || null,
      target_reps_max: (max || min) || null,
      target_spec: { type: "free" },
    });
  }

  return (
    <div className="sheet" role="dialog" aria-label="Добавить упражнение">
      <div className="sheet__backdrop" onClick={onClose} />
      <div className="sheet__body sheet__body--tall" ref={body}>
        <div className="sheet__grip" />

        {picked ? (
          <>
            <p className="sheet__title">{picked.name_ru}</p>
            <div className="stack">
              <label className="field">
                <span className="field__label">Подходы</span>
                <span className="field__control">
                  <input
                    className="field__input"
                    inputMode="numeric"
                    value={sets}
                    onChange={(e) => setSets(e.target.value)}
                  />
                </span>
              </label>
              <label className="field">
                <span className="field__label">Повторения</span>
                <span className="field__control">
                  <input
                    className="field__input"
                    inputMode="numeric"
                    placeholder="8-12"
                    value={reps}
                    onChange={(e) => setReps(e.target.value)}
                  />
                </span>
              </label>
            </div>
            <button className="button button--wide" onClick={submit}>
              Добавить
            </button>
            <button className="link-button" onClick={() => setPicked(null)}>
              Выбрать другое
            </button>
          </>
        ) : (
          <>
            <p className="sheet__title">Добавить упражнение</p>
            <ExerciseSearch
              onPick={setPicked}
              allowCreate
            />
          </>
        )}
      </div>
    </div>
  );
}
